/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core';
import classnames from 'classnames';
import {dlsColor} from '../../theme/theme';

interface MobileSideSheetArrowTypes {
  handleTapDown?: () => void;
  smallMode?: boolean;
  mobileSidesheet?: boolean;
  sideSheetMobileSwipeUp?: Function;
  mapControlBottomSheet?: boolean;
  fullHeight?: boolean;
}

const useStyles = makeStyles(theme => ({
  mobileSideSheetArrow : {
    height         : '36px',
    display        : 'flex',
    justifyContent : 'center',
    alignItems     : 'center',
    width          : '100%'
  },
  mobileSideSheetArrowWithBottomIcons : {
    height : (props: {
      mapControlBottomSheet: boolean;
      mobileSidesheet: boolean;
    }) => props?.mapControlBottomSheet ? '40px' : props?.mobileSidesheet ? '55px' : '120px',
    display        : 'flex',
    justifyContent : 'space-around',
    flexDirection  : 'column',
    alignItems     : 'center',
    width          : '100%'
  },
  mobileSideSheetIcon : {
    height          : '5px',
    backgroundColor : dlsColor('grey5'),
    borderRadius    : '50px'
  },
  width40 : {
    width : '40px'
  },
  width160 : {
    width : '160px'
  },
  mobileSideSheetIconSmall : {
    width : '78px'
  }
}));

/**
 * @MobileSideSheetArrow
 *
 * The SideSheetArrow is a tappable/draggable button ONLY for mobile
 * that can be re-used mainly for bottom sheets
 *
 * ```typescript
 *
 * <MobileSideSheetArrow handleTapDown={handleTapDown} />
 *
 * ```
 */
export const MobileSideSheetArrow = ({
  handleTapDown,
  smallMode = false,
  mobileSidesheet = false,
  sideSheetMobileSwipeUp,
  mapControlBottomSheet = false,
  fullHeight = false
}: MobileSideSheetArrowTypes) => {
  const classes= useStyles({mapControlBottomSheet, mobileSidesheet});
  return (
    <>
      <div className={fullHeight ? classes.mobileSideSheetArrowWithBottomIcons : classes.mobileSideSheetArrow}
        onTouchEnd={handleTapDown}>
        <span className={classnames(
          classes.mobileSideSheetIcon,
          smallMode && classes.mobileSideSheetIconSmall,
          fullHeight ? classes.width40 : classes.width160
        )} />
      </div>
      {mobileSidesheet && (
        sideSheetMobileSwipeUp && sideSheetMobileSwipeUp
      )}
    </>
  );
};

export default MobileSideSheetArrow;
